/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, cloneElement, useState } from 'react';
import { CardContent, CardHeader, Container, Expandable, Title } from './styles'
import PropTypes from 'prop-types';
import { Icon } from 'components';
import BetaImg from './beta.png';
import Checkbox from '../Form/CheckBox';
import Tooltip from '../Tooltip';
import Colors from "../../constants/Colors";

const propTypes = {
  title: PropTypes.string,
  enumerate: PropTypes.number,
  enumerateChildren: PropTypes.string,
};

export default function FormContainer({
  title,
  enumerate,
  enumerateChildren,
  noTitlePadding,
  children,
  maxHeight,
  hide, 
  isBeta,
  collapsedAtStart,
  isChecked,
  onCheckChange,
  hasCheckbox,
  infoContent,
  customColor,
  toggle,
  toggleChild
}) {
  const [expanded, setExpanded] = useState(true);
  const [expanding, setExpanding] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const [beforeCollapsing, setBeforeCollapsing] = useState(false);

  const accordionState = (state) => {
    setExpanding(false);
    setCollapsing(false);
    setBeforeCollapsing(false);
    setExpanded(state);
  };

  const accordionAnimation = (state) => {
    setExpanded(false);
    if (state && !expanded) {
      setExpanding(true);
      setTimeout(() => accordionState(true), 100);
    } else if (!state && expanded) {
      setBeforeCollapsing(true);
      setTimeout(() => {
        setCollapsing(true);
        setTimeout(() => accordionState(false), 100)
      }, 10);
    }
  };

  useEffect(() => {
    if (collapsedAtStart) accordionState(false);
  }, []);

  useEffect(() => {
    if (toggle == null) return
    accordionState(toggle);
  }, [toggle]);

  useEffect(() => {
    if (enumerateChildren && toggleChild == null) return
    enumerateChildren && accordionState(toggleChild);
  }, [toggleChild]);

  if (hide) return <div style={{ display: 'none' }} >{children}</div>;

  return (
    <Container className="collapsed-div">
      <CardHeader onClick={(e) => {e.stopPropagation(); accordionAnimation(!expanded)}} customColor={customColor} isExpanded={expanded} noTitlePadding={noTitlePadding}>
        <Title isChild={!!(enumerateChildren)}>
          {hasCheckbox &&
            <div style={{display: 'flex', alignItems: 'center'}} onClick={(e) => e.stopPropagation()}>
              <Checkbox
                checked={isChecked}
                onClick={(e) => {
                  onCheckChange();
                  e.stopPropagation();
                }}
              />
            </div>
          }
          <span className='enumerate-form-container'>{enumerate && enumerateChildren 
            ? `${enumerateChildren}.${enumerate} - ` 
            : enumerate 
              ? `${enumerate} - ` 
              : ''
          }</span>
          <span>{title}</span>
          {infoContent && 
            <Tooltip
              text={infoContent}
            >
              <Icon name='info' />
            </Tooltip>
          }
          {isBeta && <img src={BetaImg} width={50} style={{ marginLeft: 10 }} />}
        </Title>
        <Icon className={(!expanded || collapsing) && !expanding ? 'closed' : ''} name="arrow-up-primary-color" />
      </CardHeader>
      <CardContent
				className={expanded ? 'expanded' : beforeCollapsing ? 'before-collapsing' : (collapsing ? 'collapsing' : (expanding ? 'expanding' : ''))}
				maxHeight={maxHeight}
        customColor={customColor}
				isExpanded={expanded}
			>
        <Expandable className='collapsed-div-expandable'>
          {children}
        </Expandable>
      </CardContent>
    </Container>
  );
}

FormContainer.propTypes = propTypes;